import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Typography, Box, Icon } from 'bonfire-kindling';

import { TaxonomyCodePicker } from 'components';
import { compareFieldObjectArray } from '../../utils';

const isEqual = (a, b) =>
  compareFieldObjectArray(a, b, {
    sort: o => o.taxonomyCodeID,
    comparator: (a, b) => a.taxonomyCodeID === b.taxonomyCodeID,
  });

const SavedSearchSettingsUpsertCommodityCodes = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: { xs: 'none', md: 'inline-flex' }, alignItems: 'center' }}>
        <Icon iconName="code" />
        <Typography variant="subtitle2" component="h3" sx={{ ml: 2 }}>
          {t('settings.saved_search.edit_or_create.commodity_codes_title')}
        </Typography>
      </Box>
      <Typography variant="body1" component="p" sx={{ my: 3 }}>
        {t('settings.saved_search.edit_or_create.commodity_codes_instructions')}
      </Typography>
      <Form.Field isEqual={isEqual} name="taxonomyCodes">
        {({ input }) => (
          <TaxonomyCodePicker
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            selectedTaxonomyCodes={input.value}
            setSelectedTaxonomyCodes={updateFn => {
              const codes = updateFn(input.value);
              input.onChange(codes);
            }}
            variant="compact"
          />
        )}
      </Form.Field>
    </Box>
  );
};

export default SavedSearchSettingsUpsertCommodityCodes;
